import { readEnvVariable } from '../helpers';

export interface IAiEnv {
  openaiApiKey: string;
  anthropicApiKey: string;
  googleApiKey: string;
  ollamaBaseUrl: string;
  ollamaModel: string;
}

export function getAiEnv(): IAiEnv {
  return {
    openaiApiKey: readEnvVariable('OPENAI_API_KEY'),
    anthropicApiKey: readEnvVariable('ANTHROPIC_API_KEY'),
    googleApiKey: readEnvVariable('GOOGLE_AI_API_KEY'),
    ollamaBaseUrl: readEnvVariable('OLLAMA_BASE_URL'),
    ollamaModel: readEnvVariable('OLLAMA_MODEL'),
  };
}
